import React, { useState } from "react";
import { Box, Collapse, IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useResponsiveFontSize } from "../functions";

const Services = ({ services }) => {
  // State to track which service item is currently expanded
  const [expandedIndex, setExpandedIndex] = useState(null);

  // Function to handle expanding and collapsing the description and image
  const handleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const fontSize = useResponsiveFontSize();

  return (
    <Box sx={{ width: "100%", maxWidth: "800px", margin: "auto" }}>
      {services.map((service, index) => (
        <Box
          key={index}
          sx={{
            borderBottom: "1px solid #ddd",
            padding: "1rem 0",
            cursor: "pointer",
            fontSize: fontSize,
          }}
        >
          {/* Service Title Section */}
          <Box
            onClick={() => handleExpand(index)}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box
              sx={{
                fontWeight: expandedIndex === index ? "300" : "100",
              }}
            >
              {service.title}
            </Box>
            <IconButton
              onClick={() => handleExpand(index)}
              aria-expanded={expandedIndex === index}
              aria-label="show more"
              sx={{
                transform:
                  expandedIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s ease",
              }}
            >
              <ExpandMoreIcon />
            </IconButton>
          </Box>

          {/* Service Description and Image Section */}
          <Collapse in={expandedIndex === index} timeout="auto" unmountOnExit>
            <Box
              sx={{
                fontWeight: "100",
                textAlign: "left",
              }}
            >
              <Box
                sx={{
                  marginBottom: "1rem",
                  padding: "1rem 0",
                  marginLeft: "0.5rem",
                  fontWeight: "100",
                }}
              >
                {service.description}
              </Box>
              <Box
                component="img"
                src={service.image}
                alt={service.title}
                sx={{
                  width: "100%",
                  maxHeight: "300px",
                  borderRadius: "8px",
                  objectFit: "cover",
                  marginBottom: "1rem",
                  aspectRatio: "16/9",
                }}
              />
            </Box>
          </Collapse>
        </Box>
      ))}
    </Box>
  );
};

export default Services;
